export default [
    {name: 'home', ref: "#headerSection"},
    {name: 'about', ref: "#aboutSection"},   
    {name: 'timeline', ref: "#timelineSection"},
    {name: 'products', ref: "#productsSection"},
    {name: 'contact', ref: "#contactSection"}
]